import React from 'react';
import { Button, Col, Divider, Input, InputNumber, Row } from 'antd';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';

export default function Packages({ Form }) {
	return (
		<Form.List name='defaultPackages'>
			{(fields, { add, remove }) => (
				<>
					{fields.map(({ key, name }) => (
						<Row gutter={[16, 0]} key={key}>
							<Col sm={24} md={6}>
								<Form.Item label='Package Name' name={[name, 'packageName']}>
									<Input placeholder='For e.g. Pune To Pune 3AC, Manali to Manali Bike' autoFocus />
								</Form.Item>
							</Col>
							<Col sm={24} md={4}>
								<Form.Item
									label='Price'
									name={[name, 'packageCost']}
									rules={[
										{
											required: true,
											message: 'Price is required',
										},
									]}
								>
									<InputNumber style={{ width: '100%' }} />
								</Form.Item>
							</Col>
							<Col sm={24} md={4}>
								<Form.Item label='Kids Discount in %' name={[name, 'packageDiscountKidsInPercentage']}>
									<InputNumber style={{ width: '100%' }} max={65} min={0} />
								</Form.Item>
							</Col>
							<Col sm={24} md={4}>
								<Form.Item label='Group Discount in %' name={[name, 'packageDiscountGroupInPercentage']}>
									<InputNumber style={{ width: '100%' }} max={65} min={0} />
								</Form.Item>
							</Col>
							<Col sm={24} md={1}>
								{fields.length > 1 ? (
									<Form.Item label='&nbsp;'>
										<Button icon={<CloseOutlined />} shape='circle' onClick={() => remove(name)} />
									</Form.Item>
								) : null}
							</Col>
							<Divider style={{ margin: 0, marginBottom: 16 }} />
						</Row>
					))}
					<Row gutter={[16, 0]}>
						<Col sm={24} md={6}>
							<Form.Item>
								<Button
									icon={<PlusOutlined />}
									type='primary'
									onClick={() => {
										add();
									}}
									style={{ width: '100%' }}
								>
									Add Package
								</Button>
							</Form.Item>
						</Col>
					</Row>
				</>
			)}
		</Form.List>
	);
}
